<h2 class="popup-heading" mat-dialog-title>Show Reporting</h2>
<mat-progress-bar mode="indeterminate" *ngIf="processing"></mat-progress-bar>
<form [formGroup]="addShows" class="billing-form form-container" style="padding: 20px;">
  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Enter The Show Code</mat-label>
    <input matInput formControlName="Listeners" placeholder="Enter The Show Code" required />
  </mat-form-field>
  <div *ngIf="error_massage" class="ErrorMessage shake" style="color: red;">
    {{ error_massage }}
  </div>

  <div style="display: flex; align-items: center; gap: 5px; margin-top: 10px;">
  <mat-form-field appearance="fill" style="width: 23% !important;">
    <mat-label>From Date</mat-label>
    <!-- <input  (dateChange)="onStartDateChange($event)" matInput [matDatepicker]="picker1" [(ngModel)]="start_date"> -->
    <input matInput [matDatepicker]="picker2"[(ngModel)]="start_date" [ngModelOptions]="{standalone: true}" (dateChange)="onStartDateChange($event)">
    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>

  <!-- To Date -->
  <mat-form-field appearance="fill" style="width: 23% !important;">
    <mat-label>To Date</mat-label>
    <!-- <input (dateChange)="onEndDateChange($event)" matInput [matDatepicker]="picker2" [(ngModel)]="end_date"> -->
    <input matInput [matDatepicker]="picker2"[(ngModel)]="end_date" [ngModelOptions]="{standalone: true}" (dateChange)="onEndDateChange($event)">

    <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
  </mat-form-field>
 </div>
    <button mat-raised-button [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
      class="add-btn" (click)="billingInfo()"><span
        style="line-height: 24px;margin-right: 5px;display: inline-block;">Submit</span>
      <mat-icon style="margin-right: 6px;">check_circle</mat-icon>
    </button>
 
</form>
<span style="margin-left: 30px;" *ngIf="ladding">
  Total Listeners: <strong>{{ listeners }}</strong>&nbsp;&nbsp;&nbsp;<span>( {{ show_start_data | date:'shortDate' }} - {{ show_end_data | date:'shortDate' }} )</span>
</span>

<!-- FINGERPRINT TABLE -->
<div class="content">
  <div class="my-show-table mat-elevation-z8">
    <div class="billing-table">
      <table mat-table [dataSource]="fingerprintsData" matSort class="mat-elevation-z8 my-custom-table">

        <!-- Title -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
          <td mat-cell *matCellDef="let item">{{ item.title }}</td>
        </ng-container>

        <!-- Album -->
        <ng-container matColumnDef="album">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Album</th>
          <td mat-cell *matCellDef="let item">{{ item.album?.name }}</td>
        </ng-container>

        <!-- Artist -->
        <ng-container matColumnDef="artist">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Artist</th>
          <td mat-cell *matCellDef="let item">{{ item.artists[0]?.name }}</td>
        </ng-container>

        <!-- Release Date -->
        <ng-container matColumnDef="release_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Release Date</th>
          <td mat-cell *matCellDef="let item">{{ item.release_date }}</td>
        </ng-container>

        <!-- Score -->
        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Score</th>
          <td mat-cell *matCellDef="let item">{{ item.score }}</td>
        </ng-container>
        <ng-container matColumnDef="sample_begin_time_offset_ms">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Time</th>
          <td mat-cell *matCellDef="let item">{{ formatDuration(item.sample_begin_time_offset_ms) }}</td>
        </ng-container>
        <ng-container matColumnDef="sample_end_time_offset_ms">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>End Time</th>
          <td mat-cell *matCellDef="let item">{{ formatDuration(item.sample_end_time_offset_ms) }}</td>
        </ng-container>
        <ng-container matColumnDef="duration_ms">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Song Time</th>
          <td mat-cell *matCellDef="let item"> {{ formatDuration(item.sample_end_time_offset_ms -
            item.sample_begin_time_offset_ms) }}</td>


        </ng-container>
        <ng-container matColumnDef="song_time_ms">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Time Played</th>
          <td mat-cell *matCellDef="let item">{{ formatDuration(item.song_time_ms) }}</td>
        </ng-container>


        <!-- Table rows -->
        <tr mat-header-row *matHeaderRowDef="fingerprints_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: fingerprints_columns;"></tr>

        <!-- Empty State -->
        <tr class="mat-row" *matNoDataRow>
          <td colspan="5" class="mat-cell">No Data Found.</td>
        </tr>
      </table>

      <!-- Pagination (conditionally visible) -->
      <mat-paginator [class]="total_reports > 5 ? '' : 'hidden_dropdown'" [pageSizeOptions]="[5]" [pageSize]="5"
        aria-label="Select page of the records">
      </mat-paginator>
    </div>
  </div>
</div>